import { TopPage } from "@/components/elements/TopPage";
import { ManagementForm } from "@/features/rso/components/Form";

import { Stack } from "@mui/material";
import { FC } from "react";
import { useRef } from "react";
import { styled } from "@mui/system";

type TCreatePageProps = {};

export const CreatePage: FC<TCreatePageProps> = () => {
  const formRef = useRef<{ submit: () => void }>(null);

  return (
    <PartnerWrapper gap={4}>
      <TopPage
        title="顧客情報の編集"
        description="新しい事業者の基本情報および契約情報を入力してシステムに登録します。登録後、顧客ユーザーの追加も必要です。"
        enablePageBack={false}
      />
      <ManagementForm ref={formRef} />
    </PartnerWrapper>
  );
};

const PartnerWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
